import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { ModuleButton, ModuleButtonsState } from './types';

const initialState: ModuleButtonsState = {
  buttons: [],
};

export const moduleButtonsSlice = createSlice({
  name: 'moduleButtons',
  initialState,
  reducers: {
    setModuleButtons: (state, action: PayloadAction<ModuleButton[]>) => {
      state.buttons = action.payload;
    },
    clearModuleButtons: (state) => {
      state.buttons = [];
    },
  },
});

export const { setModuleButtons, clearModuleButtons } =
  moduleButtonsSlice.actions;

const reducer = { moduleButtons: moduleButtonsSlice.reducer };

export default reducer;
